import ServiceTemplate from 'src/components/atomic/template/Service'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import SessionStorageUtils from 'src/utils/SessionStorage.utils'

import { Cmdtypes } from 'src/constants/cmdtypes'
import { commonUtils } from 'src/utils/common.utils'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import useMatchHook from 'src/hooks/useMatch.hook'
import { CryptoUtils } from 'src/utils/Crypto.utils'

import { RequestDataBody } from 'src/types/websocket'
import { SocketManager, SocketSender } from 'src/api/socket'
import useScrollTopHook from 'src/hooks/useScrollTop.hook'
import {
  setExplorerFileListLoading,
  setExplorerStorageLoading,
} from 'src/store/Reducer/page/explorerPageSlice'

const ServicePage = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const explorerFileType = useLocation()?.state?.Type
  const { loginStatus, RecaptchaTokenUpdateFlag } = useAppSelector(
    (state: RootState) => state.common,
  )
  const { Connection } = useAppSelector((state: RootState) => state.connection)
  const { decryptionVerify } = CryptoUtils
  const { getStorageData } = SessionStorageUtils()
  const { Timezone, externalDefaultPath, InternalDefaultPath, DownloadsDefaultPath } = commonUtils
  const UserInfoData = getStorageData('userInfo')
  const TokenData = getStorageData('token')
  const deviceAuth = useAppSelector((state: RootState) => state.deviceAuth)
  const { ExplorerStorageLoading, ExplorerFileListLoading } = useAppSelector(
    (state: RootState) => state.ExplorerPage,
  )
  const {
    m_setting,
    m_explorer_detail_param,
    m_location_detail,
    m_explorer_detail,
    m_explorer,
    m_home,
    m_location,
  } = useMatchHook()
  //세션 스토리지에 userInfo 정보가 없으면 루트 페이지로 이동
  useEffect(() => {
    !loginStatus && !UserInfoData && navigate('/')
  }, [UserInfoData, navigate, loginStatus])

  useScrollTopHook()

  //새로고침시에 리캡챠에 refresh 된 후 소캣open후 로그인 요청
  useEffect(() => {
    if (RecaptchaTokenUpdateFlag) {
      const initializeSocket = async () => dispatch(SocketManager())
      const LoginReqData = {
        SNSType: UserInfoData.SNSType,
        Email: UserInfoData.Email,
        VerifyPin: UserInfoData.VerifyPin,
        Token: TokenData,
        TimeZone: Timezone,
      }
      initializeSocket().then(() => {
        dispatch(SocketSender<RequestDataBody.Login>(Cmdtypes.LOGIN, LoginReqData))
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [RecaptchaTokenUpdateFlag])

  useEffect(() => {
    if ((m_home || m_setting) && loginStatus) {
      dispatch(SocketSender<unknown>(Cmdtypes.HOME_INFO))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [m_home, m_setting, loginStatus, Connection, Cmdtypes.HOME_INFO, dispatch])

  useEffect(() => {
    if ((m_location || m_location_detail) && loginStatus && decryptionVerify()) {
      dispatch(SocketSender<unknown>(Cmdtypes.LOCATION_INFO))
      Connection && dispatch(SocketSender<unknown>(Cmdtypes.CURRENT_LOCATION_INFO))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [m_location, m_location_detail, loginStatus, Connection, deviceAuth.Location])

  useEffect(() => {
    if (m_explorer && loginStatus && Connection) {
      dispatch(setExplorerStorageLoading(true))
      dispatch(SocketSender<unknown>(Cmdtypes.EXPLORER_STORAGE_SIZE))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [m_explorer, loginStatus, Connection])

  // 20초간 storageInfo 응답 없을 시 timeout 처리
  useEffect(() => {
    if (!ExplorerStorageLoading) return

    const timeout = setTimeout(() => {
      dispatch(setExplorerStorageLoading(false))
    }, 20000)

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [ExplorerStorageLoading, dispatch])

  useEffect(() => {
    if (m_explorer_detail && loginStatus && Connection) {
      const createReqData = (path: string) => {
        return {
          Path: path,
          Page: 1,
        }
      }
      dispatch(setExplorerFileListLoading(true))
      switch (m_explorer_detail_param) {
        case 'INTERNAL':
          dispatch(
            SocketSender<RequestDataBody.ExplorerFileInnerList>(
              Cmdtypes.EXPLORER_FOLDER_INNER,
              createReqData(InternalDefaultPath),
            ),
          )
          break
        case 'EXTERNAL':
          dispatch(
            SocketSender<RequestDataBody.ExplorerFileInnerList>(
              Cmdtypes.EXPLORER_FOLDER_INNER,
              createReqData(externalDefaultPath),
            ),
          )
          break
        case 'Downloads':
          dispatch(
            SocketSender<RequestDataBody.ExplorerFileInnerList>(
              Cmdtypes.EXPLORER_FOLDER_INNER,
              createReqData(DownloadsDefaultPath),
            ),
          )
          break
        default:
          dispatch(
            SocketSender<RequestDataBody.ExplorerFileList>(Cmdtypes.EXPLORER_FILE_LIST, {
              Type: explorerFileType as number,
              Page: 1,
            }),
          )
          break
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [m_explorer_detail, loginStatus, Connection])

  // 20초간 file list 응답 없을 시 timeout 처리
  useEffect(() => {
    if (!ExplorerFileListLoading) return

    const timeout = setTimeout(() => {
      dispatch(setExplorerFileListLoading(false))
    }, 20000)

    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [ExplorerFileListLoading, dispatch])

  useEffect(() => {
    if (Connection && loginStatus) {
      setTimeout(() => {
        dispatch(SocketSender<unknown>(Cmdtypes.BATTERY_INFO))
      }, 300)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Connection, loginStatus, pathname])

  return <ServiceTemplate />
}
export default ServicePage
